// $(window).on("load resize scroll",function(){
//     navDropdownHeight();
// });

$(function () {
    menu_trigger = $('.nav-toggle');
    nav = $('nav');
    body = $('body');

    menu_trigger.click(function () {
        $(this).toggleClass('nav-toggle--active');
        nav.toggleClass('nav--active');
        body.toggleClass('overflow--hidden');

        if ($(this).attr('aria-expanded') === 'true') {
            $(this).attr('aria-expanded', 'false');
        } else {
            $(this).attr('aria-expanded', 'true');
        }
    });

    // nav_icon.click(function () {
    //     $(this).toggleClass('nav__icon--active');
    //     $(this).closest('.nav__item').find('.nav__dropdown').toggleClass('nav__dropdown--active');
    // });

    // // Close mobile nav by click outside
    // $(document).mouseup(function (e) {
    //     if (!nav.is(e.target) && !menu_trigger.is(e.target) && nav.has(e.target).length === 0) {
    //         menu_trigger.removeClass('nav-toggle--active');
    //         nav.removeClass('nav--active');
    //         body.removeClass('body--overlay');
    //     }
    // });

});

// function navDropdownHeight() {
//     if ($(window).width() < 992) {
//         $('.nav__dropdown').each(function () {

//             dropdown_height = $(this)[0].scrollHeight + 30;
//             $(this).parent().css('max-height', dropdown_height);
//         });
//     }
// }